import React, { useState } from 'react';
import { motion } from 'framer-motion';

const VideoSection: React.FC = () => {
  const [isPlaying, setIsPlaying] = useState(false);

  const togglePlay = () => {
    setIsPlaying(!isPlaying);
  };

  return (
    <section className="py-20 px-4 bg-gradient-to-br from-rose-50 to-violet-50">
      <div className="max-w-6xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl md:text-5xl font-display font-bold text-gradient mt-2 mb-6">
            Our Story
          </h2>
          <p className="text-xl text-slate-600 max-w-3xl mx-auto">
            Watch our journey together unfold in this beautiful video
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          whileInView={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          viewport={{ once: true }}
          className="relative max-w-6xl mx-auto"
        >
          <div className="relative rounded-3xl overflow-hidden shadow-2xl bg-slate-900">
            {/* Video Player */}
            <div className="relative aspect-video bg-slate-900">
              <video
                src="/us.mov"
                controls
                className="w-full h-full object-cover"
                // poster="/couple-photo.jpg"
                onPlay={() => setIsPlaying(true)}
                onPause={() => setIsPlaying(false)}
                onEnded={() => setIsPlaying(false)}
              >
                Your browser does not support the video tag.
              </video>
              
              {/* Custom Play Button Overlay */}
              {!isPlaying && (
                <div className="absolute inset-0 bg-black/20 flex items-center justify-center">
                  <motion.button
                    onClick={() => {
                      const video = document.querySelector('video');
                      if (video) {
                        video.play();
                        setIsPlaying(true);
                      }
                    }}
                    whileHover={{ scale: 1.1 }}
                    whileTap={{ scale: 0.9 }}
                    className="w-20 h-20 bg-white/90 rounded-full flex items-center justify-center shadow-lg hover:bg-white transition-colors duration-300"
                  >
                    <svg className="w-8 h-8 text-rose-500 ml-1" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M8 5v14l11-7z"/>
                    </svg>
                  </motion.button>
                </div>
              )}
            </div>


            {/* Decorative Elements */}
            <div className="absolute -top-4 -left-4 w-8 h-8 bg-rose-400 rounded-full opacity-60 animate-pulse" />
            <div className="absolute -top-2 -right-6 w-6 h-6 bg-violet-400 rounded-full opacity-60 animate-pulse" style={{ animationDelay: '1s' }} />
            <div className="absolute -bottom-4 -right-4 w-10 h-10 bg-emerald-400 rounded-full opacity-60 animate-pulse" style={{ animationDelay: '2s' }} />
            <div className="absolute -bottom-2 -left-6 w-4 h-4 bg-amber-400 rounded-full opacity-60 animate-pulse" style={{ animationDelay: '0.5s' }} />
          </div>
        </motion.div>

        {/* Video Description */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.4 }}
          viewport={{ once: true }}
          className="text-center mt-12"
        >
          <p className="text-lg text-slate-600 max-w-2xl mx-auto leading-relaxed">
            From our first meeting to this beautiful day, every moment has been captured with love. 
            This video tells the story of how two hearts found each other and decided to spend forever together.
          </p>
        </motion.div>
      </div>
    </section>
  );
};

export default VideoSection;
